function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Create_wallet_icon"
}, React.createElement("rect", {
  width: 22,
  height: 24
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Create_wallet_icon",
  "data-name": "Create wallet icon",
  clipPath: "url(#clip-Create_wallet_icon)"
}, React.createElement("rect", {
  width: 22,
  height: 24,
  fill: "rgba(255,255,255,0)"
}), React.createElement("g", {
  id: "Group_707",
  "data-name": "Group 707",
  transform: "translate(0 1.292)"
}, React.createElement("g", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  transform: "translate(0 4.579)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, React.createElement("rect", {
  width: 21.5,
  height: 15.13,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 20,
  height: 13.63,
  fill: "none"
})), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M33.333,307.509l5.773-5.176,2.986,2.787",
  transform: "translate(-30.148 -302.333)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M40.667,308.181,48.032,304l1.642,2.737",
  transform: "translate(-30.713 -303.005)",
  fill: "none",
  stroke: "#707070",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), React.createElement("text", {
  id: "Path_18",
  "data-name": "+",
  transform: "translate(6 4)",
  stroke: "#707070",
  fill: "#707070",
  fontSize: 15,
  fontFamily: "Montserrat-Medium, Montserrat",
  fontWeight: 500
}, React.createElement("tspan", {
  x: 0,
  y: 15
}, "+")));

var SvgCreateWalletIcon = function SvgCreateWalletIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCreateWalletIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create-wallet-icon.928ce3c4.svg";
export { ForwardRef as ReactComponent };